import { Button, Grid, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import HeaderGeneral from "../../../components/Header/HeaderGeneral";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import SusunanKeluargaTable from "../SusunanKeluargaPage/Components/SusunanKeluargaTable";
import RiwayatPekerjaanModal from "./Components/RiwayatPekerjaanModal";
import RiwayatPekerjaanable from "./Components/RiwayatPekerjaanTable";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import useFetchAllRiwayatPekerjaan from "../../../api/effects/queries/RiwayatPekerjaan/useFetchAllRiwayatPekerjaan";


const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));
const ButtonGrid = styled(Grid)(({ theme }) => ({
  paddingRight: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));

export default function RiwayatPekerjaanPage() {
  const [modalState, setModalState] = useState(false);

  const handleOpenModal = () => {
    setModalState(!modalState);
  };

  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   setLoading(false);
  // }, []);

  // if (loading) {
  //   return (
  //     <GridSkeleton justifyContent="center" alignItems="center">
  //       <SkeletonText variant="text" />
  //       <SkeletonTable variant="rectangular" />
  //     </GridSkeleton>
  //   );
  // }
  const { data: pekerjaanData, isLoading: isPekerjaanLoading } = useFetchAllRiwayatPekerjaan();
  const pageIsLoading = isPekerjaanLoading;

  return (
    <>
      <RiwayatPekerjaanModal open={modalState} handleClose={handleOpenModal} />
      <LoadingOverlay isLoading={pageIsLoading}>
        <TitleGrid container item xs={12} justifyContent="flex-start">
          <Typography variant="h5">Riwayat Pekerjaan</Typography>
        </TitleGrid>
        <RiwayatPekerjaanable />
        <ButtonGrid container item xs={12} justifyContent="flex-end">
          <Button variant="contained" onClick={handleOpenModal}>
            Tambah Riwayat Pekerjaan
          </Button>
        </ButtonGrid>
      </LoadingOverlay>
    </>
  );
}
